import { TRootState } from '../@types/redux';

export const selectModalProductCharacteristic= ( state: TRootState) =>state.productCharacteristics.productCharacteristicModalIsOpen

export const selectIsUpdateProductCharacteristic= ( state: TRootState) =>state.productCharacteristics.isUpdateProductCharacteristic

export const selectProductCharacteristicForUpdate= ( state: TRootState) =>state.productCharacteristics.productCharacteristicForUpdate

export const selectProductCharacteristicRefreshTable= ( state: TRootState) =>state.productCharacteristics.refreshTableProductCharacteristic